import React from 'react'
import {FormControlLabel, Grid, Avatar, Button, Link} from '@mui/material'
import WbSwitch from '../../../../common/WbSwitch'
import WbTextField from '../../../../common/WbTextField'
import {AUDIENCE} from '../../../../../utils/constants'
import Stack from '@mui/material/Stack'
import WbButton from '../../../../common/WbButton'
import EmojiPicker, {Emoji} from 'emoji-picker-react'
import Box from '@mui/material/Box'
import WbFileUpload from '../../../../common/WbFileUpload'
import {Config} from '../../../../../utils/Config'

export function MultiOptionImageOption({
  question,
  updateQuestion,
  i,
  audience,
  isPriority,
}) {
  return (
    <div className="options-panel">
      <Grid item xs={12} lg={12} textAlign={'center'} mb={1}>
        {question.multiOptionResponseAttributes[i].staffImage ||
        question.multiOptionResponseAttributes[i].parentImage ||
        question.multiOptionResponseAttributes[i].pupilImage ? (
          <img
            src={`${Config.BASE_URL}/Artifact/download?fileName=${
              audience === AUDIENCE.STAFF
                ? question.multiOptionResponseAttributes[i].staffImage
                : audience === AUDIENCE.PARENT
                  ? question.multiOptionResponseAttributes[i].parentImage
                  : question.multiOptionResponseAttributes[i].pupilImage
            }`}
            width={100}
          />
        ) : (
          <DummyImage width={98} height={72} />
        )}
      </Grid>
      <Grid item xs={12} lg={12} textAlign="center">
        {question.multiOptionResponseAttributes[i].staffEmoji ||
        question.multiOptionResponseAttributes[i].parentEmoji ||
        question.multiOptionResponseAttributes[i].pupilEmoji ? (
          <WbFileUpload
            setImageName={url => {
              var options = [...question.multiOptionResponseAttributes]
              if (isPriority) {
                if (audience === AUDIENCE.STAFF) {
                  options[i].pupilImage = url
                  options[i].parentImage = url
                  options[i].staffImage = url
                }
                if (audience === AUDIENCE.PARENT) {
                  options[i].pupilImage = url
                  options[i].parentImage = url
                }
                if (audience === AUDIENCE.STUDENT) {
                  options[i].pupilImage = url
                }
              } else {
                if (audience === AUDIENCE.STAFF) {
                  options[i].staffImage = url
                }
                if (audience === AUDIENCE.PARENT) {
                  options[i].parentImage = url
                }
                if (audience === AUDIENCE.STUDENT) {
                  options[i].pupilImage = url
                }
              }
              updateQuestion({
                ...question,
                multiOptionResponseAttributes: [...options],
                followupQuestions: [...question.followupQuestions],
                questionSettings: {...question.questionSettings},
              })
            }}
          />
        ) : (
          <WbFileUpload
            button={true}
            setImageName={url => {
              var options = [...question.multiOptionResponseAttributes]
              if (isPriority) {
                if (audience === AUDIENCE.STAFF) {
                  options[i].pupilImage = url
                  options[i].parentImage = url
                  options[i].staffImage = url
                }
                if (audience === AUDIENCE.PARENT) {
                  options[i].pupilImage = url
                  options[i].parentImage = url
                }
                if (audience === AUDIENCE.STUDENT) {
                  options[i].pupilImage = url
                }
              } else {
                if (audience === AUDIENCE.STAFF) {
                  options[i].staffImage = url
                }
                if (audience === AUDIENCE.PARENT) {
                  options[i].parentImage = url
                }
                if (audience === AUDIENCE.STUDENT) {
                  options[i].pupilImage = url
                }
              }
              updateQuestion({
                ...question,
                multiOptionResponseAttributes: [...options],
                followupQuestions: [...question.followupQuestions],
                questionSettings: {...question.questionSettings},
              })
            }}
          />
        )}
      </Grid>
      <Grid item xs={12} lg={12} mb={1}>
        <div className="followup-switch">
          <FormControlLabel
            control={
              <WbSwitch
                size="small"
                checked={
                  audience === AUDIENCE.STAFF
                    ? question.multiOptionResponseAttributes[i]
                        .showStaffImageLabel
                    : audience === AUDIENCE.PARENT
                      ? question.multiOptionResponseAttributes[i]
                          .showParentImageLabel
                      : question.multiOptionResponseAttributes[i]
                          .showPupilImageLabel
                }
                onChange={e => {
                  let q = [...question.multiOptionResponseAttributes]
                  if (isPriority) {
                    if (audience === AUDIENCE.STAFF) {
                      q[i].showPupilImageLabel = e.target.checked
                      q[i].showParentImageLabel = e.target.checked
                      q[i].showStaffImageLabel = e.target.checked
                    }
                    if (audience === AUDIENCE.PARENT) {
                      q[i].showPupilImageLabel = e.target.checked
                      q[i].showParentImageLabel = e.target.checked
                    }
                    if (audience === AUDIENCE.STUDENT) {
                      q[i].showPupilImageLabel = e.target.checked
                    }
                  } else {
                    if (audience === AUDIENCE.STAFF) {
                      q[i].showStaffImageLabel = e.target.checked
                    }
                    if (audience === AUDIENCE.PARENT) {
                      q[i].showParentImageLabel = e.target.checked
                    }
                    if (audience === AUDIENCE.STUDENT) {
                      q[i].showPupilImageLabel = e.target.checked
                    }
                  }
                  updateQuestion({
                    ...question,
                    followupQuestions: [...question.followupQuestions],
                    questionSettings: {...question.questionSettings},
                    multiOptionResponseAttributes: [...q],
                  })
                }}
              ></WbSwitch>
            }
            label="Show Label"
          ></FormControlLabel>
        </div>
      </Grid>
      <Grid item xs={12} lg={12}>
        <MultiOptionText
          type={1}
          question={question}
          updateQuestion={updateQuestion}
          i={i}
          audience={audience}
          isPriority={isPriority}
        />
        <MultipleOptionFollowup
          question={question}
          i={i}
          isPriority={isPriority}
          updateQuestion={updateQuestion}
        />
        {question.hasFollowup &&
          question.followupQuestions.findIndex(
            x =>
              x.followupValue ===
              question.multiOptionResponseAttributes[i].value
          ) > -1 && (
            <MultiOptionFollowupText
              question={question}
              i={i}
              isPriority={isPriority}
              updateQuestion={updateQuestion}
              audience={audience}
            />
          )}
      </Grid>
    </div>
  )
}

export function MultiOptionEmojiOption({
  question,
  updateQuestion,
  i,
  audience,
  isPriority,
}) {
  const [showEmoji, setShowEmoji] = React.useState(false)

  return (
    <div className="options-panel">
      <Grid item xs={12} lg={12} textAlign={'center'} mb={1}>
        {question.multiOptionResponseAttributes[i].staffEmoji ||
        question.multiOptionResponseAttributes[i].parentEmoji ||
        question.multiOptionResponseAttributes[i].pupilEmoji ? (
          <Emoji
            unified={
              audience === AUDIENCE.STAFF
                ? question.multiOptionResponseAttributes[i].staffEmoji
                : audience === AUDIENCE.PARENT
                  ? question.multiOptionResponseAttributes[i].parentEmoji
                  : question.multiOptionResponseAttributes[i].pupilEmoji
            }
            size={64}
          />
        ) : (
          <DummyImage width={98} height={72} />
        )}
      </Grid>
      <Grid item xs={12} lg={12} textAlign="center">
        {question.multiOptionResponseAttributes[i].staffEmoji ||
        question.multiOptionResponseAttributes[i].parentEmoji ||
        question.multiOptionResponseAttributes[i].pupilEmoji ? (
          <Link
            href="#"
            onClick={e => setShowEmoji(!showEmoji)}
            color="#E84F6B"
          >
            Change Emoji
          </Link>
        ) : (
          <WbButton
            CustomButtonText={'Choose Emoji'}
            onClick={e => setShowEmoji(!showEmoji)}
          />
        )}
        {showEmoji && (
          <EmojiPicker
            skinTonesDisabled
            style={{position: 'absolute', zIndex: 9999}}
            onEmojiClick={e => {
              var options = [...question.multiOptionResponseAttributes]

              if (isPriority) {
                if (audience === AUDIENCE.STAFF) {
                  options[i].pupilEmoji = e.unified
                  options[i].parentEmoji = e.unified
                  options[i].staffEmoji = e.unified
                }
                if (audience === AUDIENCE.PARENT) {
                  options[i].pupilEmoji = e.unified
                  options[i].parentEmoji = e.unified
                }
                if (audience === AUDIENCE.STUDENT) {
                  options[i].pupilEmoji = e.unified
                }
              } else {
                if (audience === AUDIENCE.STAFF) {
                  options[i].staffEmoji = e.unified
                }
                if (audience === AUDIENCE.PARENT) {
                  options[i].parentEmoji = e.unified
                }
                if (audience === AUDIENCE.STUDENT) {
                  options[i].pupilEmoji = e.unified
                }
              }
              updateQuestion({
                ...question,
                multiOptionResponseAttributes: [...options],
                followupQuestions: [...question.followupQuestions],
                questionSettings: {...question.questionSettings},
              })
              setShowEmoji(false)
            }}
          />
        )}
      </Grid>
      <Grid item xs={12} lg={12} mb={1}>
        <div className="followup-switch">
          <FormControlLabel
            control={
              <WbSwitch
                size="small"
                checked={
                  audience === AUDIENCE.STAFF
                    ? question.multiOptionResponseAttributes[i]
                        .showStaffEmojiLabel
                    : audience === AUDIENCE.PARENT
                      ? question.multiOptionResponseAttributes[i]
                          .showParentEmojiLabel
                      : question.multiOptionResponseAttributes[i]
                          .showPupilEmojiLabel
                }
                onChange={e => {
                  let q = [...question.multiOptionResponseAttributes]
                  if (isPriority) {
                    if (audience === AUDIENCE.STAFF) {
                      q[i].showPupilEmojiLabel = e.target.checked
                      q[i].showParentEmojiLabel = e.target.checked
                      q[i].showStaffEmojiLabel = e.target.checked
                    }
                    if (audience === AUDIENCE.PARENT) {
                      q[i].showPupilEmojiLabel = e.target.checked
                      q[i].showParentEmojiLabel = e.target.checked
                    }
                    if (audience === AUDIENCE.STUDENT) {
                      q[i].showPupilEmojiLabel = e.target.checked
                    }
                  } else {
                    if (audience === AUDIENCE.STAFF) {
                      q[i].showStaffEmojiLabel = e.target.checked
                    }
                    if (audience === AUDIENCE.PARENT) {
                      q[i].showParentEmojiLabel = e.target.checked
                    }
                    if (audience === AUDIENCE.STUDENT) {
                      q[i].showPupilEmojiLabel = e.target.checked
                    }
                  }
                  updateQuestion({
                    ...question,
                    followupQuestions: [...question.followupQuestions],
                    questionSettings: {...question.questionSettings},
                    multiOptionResponseAttributes: [...q],
                  })
                }}
              ></WbSwitch>
            }
            label="Show Label"
          ></FormControlLabel>
        </div>
      </Grid>
      <Grid item xs={12} lg={12}>
        <MultiOptionText
          type={1}
          question={question}
          updateQuestion={updateQuestion}
          i={i}
          audience={audience}
          isPriority={isPriority}
        />
        <MultipleOptionFollowup
          question={question}
          i={i}
          isPriority={isPriority}
          updateQuestion={updateQuestion}
        />
        {question.hasFollowup &&
          question.followupQuestions.findIndex(
            x =>
              x.followupValue ===
              question.multiOptionResponseAttributes[i].value
          ) > -1 && (
            <MultiOptionFollowupText
              question={question}
              i={i}
              isPriority={isPriority}
              updateQuestion={updateQuestion}
              audience={audience}
            />
          )}
      </Grid>
    </div>
  )
}

export function MultiOptionTextOption(
  question,
  updateQuestion,
  i,
  audience,
  isPriority
) {
  return (
    <div className="options-panel">
      <MultiOptionText
        type={2}
        question={question}
        updateQuestion={updateQuestion}
        i={i}
        audience={audience}
        isPriority={isPriority}
      />
      <MultipleOptionFollowup
        question={question}
        i={i}
        isPriority={isPriority}
        updateQuestion={updateQuestion}
      />
      {question.hasFollowup &&
        question.followupQuestions.findIndex(
          x =>
            x.followupValue === question.multiOptionResponseAttributes[i].value
        ) > -1 && (
          <MultiOptionFollowupText
            question={question}
            i={i}
            isPriority={isPriority}
            updateQuestion={updateQuestion}
            audience={audience}
          />
        )}
    </div>
  )
}

function MultiOptionText({
  type,
  question,
  updateQuestion,
  i,
  audience,
  isPriority,
}) {
  return (
    <Stack direction="row" spacing={1}>
      <WbTextField
        sx={{width: '80%'}}
        label={type === 1 ? 'Label' : 'Answer ' + (i + 1)}
        value={
          audience === AUDIENCE.STAFF
            ? question.multiOptionResponseAttributes[i].staffText
            : audience === AUDIENCE.PARENT
              ? question.multiOptionResponseAttributes[i].parentText
              : question.multiOptionResponseAttributes[i].pupilText
        }
        onChange={e => {
          let q = {
            ...question,
            questionSettings: {...question.questionSettings},
            followupQuestions: [...question.followupQuestions],
            multiOptionResponseAttributes: [
              ...question.multiOptionResponseAttributes,
            ],
          }
          if (isPriority) {
            if (audience === AUDIENCE.STAFF) {
              if (
                q.multiOptionResponseAttributes[i].pupilText ===
                q.multiOptionResponseAttributes[i].staffText
              )
                q.multiOptionResponseAttributes[i].pupilText = e.target.value
              if (
                q.multiOptionResponseAttributes[i].parentText ===
                q.multiOptionResponseAttributes[i].staffText
              )
                q.multiOptionResponseAttributes[i].parentText = e.target.value
              q.multiOptionResponseAttributes[i].staffText = e.target.value
            }
            if (audience === AUDIENCE.PARENT) {
              if (
                q.multiOptionResponseAttributes[i].pupilText ===
                q.multiOptionResponseAttributes[i].parentText
              )
                q.multiOptionResponseAttributes[i].pupilText = e.target.value
              q.multiOptionResponseAttributes[i].parentText = e.target.value
            }
            if (audience === AUDIENCE.STUDENT) {
              q.multiOptionResponseAttributes[i].pupilText = e.target.value
            }
          } else {
            if (audience === AUDIENCE.STAFF)
              q.multiOptionResponseAttributes[i].staffText = e.target.value
            if (audience === AUDIENCE.PARENT)
              q.multiOptionResponseAttributes[i].parentText = e.target.value
            if (audience === AUDIENCE.STUDENT)
              q.multiOptionResponseAttributes[i].pupilText = e.target.value
          }
          updateQuestion({
            ...q,
            questionSettings: {...q.questionSettings},
            followupQuestions: [...q.followupQuestions],
            multiOptionResponseAttributes: [...q.multiOptionResponseAttributes],
          })
        }}
      />
      <WbTextField
        sx={{width: '20%'}}
        value={question.multiOptionResponseAttributes[i].numValue}
        label={'Num ' + (i + 1)}
        disabled={!question.hasCustomValue}
        onChange={e => {
          let options = [...question.multiOptionResponseAttributes]
          if (e.target.value != '') {
            options[i].numValue = parseInt(e.target.value)
          } else {
            options[i].numValue = null
          }
          updateQuestion({
            ...question,
            multiOptionResponseAttributes: [...options],
            followupQuestions: [...question.followupQuestions],
            questionSettings: {...question.questionSettings},
          })
        }}
      />
    </Stack>
  )
}

function MultipleOptionFollowup({question, updateQuestion, i, isPriority}) {
  return (
    <div className="followup-switch">
      <FormControlLabel
        control={
          <WbSwitch
            size="small"
            checked={
              question.hasFollowup &&
              question.followupQuestions.findIndex(
                x =>
                  x.followupValue ===
                  question.multiOptionResponseAttributes[i].value
              ) > -1
            }
            onChange={e => {
              if (e.target.checked) {
                let q = [...question.followupQuestions]
                q.push({
                  followupValue:
                    question.multiOptionResponseAttributes[i].value,
                  staffFollowupText: null,
                  pupilFollowupText: null,
                  parentFollowupText: null,
                })
                updateQuestion({
                  ...question,
                  hasFollowup: true,
                  followupQuestions: [...q],
                  questionSettings: {...question.questionSettings},
                  multiOptionResponseAttributes: [
                    ...question.multiOptionResponseAttributes,
                  ],
                })
              } else {
                let q = [...question.followupQuestions]
                q = q.filter(
                  f =>
                    f.followupValue !==
                    question.multiOptionResponseAttributes[i].value
                )
                updateQuestion({
                  ...question,
                  hasFollowup: q.length > 0 ? true : false,
                  followupQuestions: [...q],
                  questionSettings: {...question.questionSettings},
                  multiOptionResponseAttributes: [
                    ...question.multiOptionResponseAttributes,
                  ],
                })
              }
            }}
            disabled={!isPriority}
          ></WbSwitch>
        }
        label="Ask follow up question"
      ></FormControlLabel>
    </div>
  )
}

function MultiOptionFollowupText({
  question,
  updateQuestion,
  i,
  isPriority,
  audience,
}) {
  return (
    <WbTextField
      sx={{marginTop: '10px'}}
      label="Follow up question text"
      value={
        audience === AUDIENCE.STAFF
          ? question.followupQuestions[
              question.followupQuestions.findIndex(
                x =>
                  x.followupValue ===
                  question.multiOptionResponseAttributes[i].value
              )
            ]?.staffFollowupText
          : audience === AUDIENCE.PARENT
            ? question.followupQuestions[
                question.followupQuestions.findIndex(
                  x =>
                    x.followupValue ===
                    question.multiOptionResponseAttributes[i].value
                )
              ]?.parentFollowupText
            : question.followupQuestions[
                question.followupQuestions.findIndex(
                  x =>
                    x.followupValue ===
                    question.multiOptionResponseAttributes[i].value
                )
              ]?.pupilFollowupText
      }
      onChange={e => {
        let q = [...question.followupQuestions]
        let indx = question.followupQuestions.findIndex(
          x =>
            x.followupValue === question.multiOptionResponseAttributes[i].value
        )
        if (indx === -1) {
          return
        }
        if (isPriority) {
          if (audience === AUDIENCE.STAFF) {
            if (q[indx]?.pupilFollowupText === q[indx].staffFollowupText)
              q[indx].pupilFollowupText = e.target.value
            if (q[indx].parentFollowupText === q[indx].staffFollowupText)
              q[indx].parentFollowupText = e.target.value
            q[indx].staffFollowupText = e.target.value
          }
          if (audience === AUDIENCE.PARENT) {
            if (
              q[
                question.followupQuestions.findIndex(
                  x =>
                    x.followupValue ===
                    question.multiOptionResponseAttributes[i].value
                )
              ].pupilFollowupText ===
              q[
                question.followupQuestions.findIndex(
                  x =>
                    x.followupValue ===
                    question.multiOptionResponseAttributes[i].value
                )
              ].parentFollowupText
            )
              q[
                question.followupQuestions.findIndex(
                  x =>
                    x.followupValue ===
                    question.multiOptionResponseAttributes[i].value
                )
              ].pupilFollowupText = e.target.value
            q[
              question.followupQuestions.findIndex(
                x =>
                  x.followupValue ===
                  question.multiOptionResponseAttributes[i].value
              )
            ].parentFollowupText = e.target.value
          }
          if (audience === AUDIENCE.STUDENT) {
            q[
              question.followupQuestions.findIndex(
                x =>
                  x.followupValue ===
                  question.multiOptionResponseAttributes[i].value
              )
            ].pupilFollowupText = e.target.value
          }
        } else {
          if (audience === AUDIENCE.STAFF)
            q[indx].staffFollowupText = e.target.value
          if (audience === AUDIENCE.PARENT)
            q[indx].parentFollowupText = e.target.value
          if (audience === AUDIENCE.STUDENT)
            q[indx].pupilFollowupText = e.target.value
        }
        updateQuestion({
          ...question,
          followupQuestions: [...q],
          questionSettings: {...question.questionSettings},
          multiOptionResponseAttributes: [
            ...question.multiOptionResponseAttributes,
          ],
        })
      }}
    ></WbTextField>
  )
}

function DummyImage({width, height}) {
  return (
    <Grid
      container
      direction="row"
      sx={{
        marginBottom: 1,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Avatar
        variant="square"
        sx={{
          width: width,
          height: height,
          bgcolor: 'grey.100',
          border: '1px solid #E2E2E2',
        }}
      >
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.92773 3.80002V18.2H20.255V3.80002H1.92773ZM3.23683 5.10911H18.9459V14.2112L15.4893 10.7343L15.0186 10.2637L12.0529 13.2294L8.28926 9.42518L7.81864 8.95456L3.23683 13.5364V5.10911ZM16.3277 6.4182C15.9805 6.4182 15.6476 6.55612 15.4021 6.80162C15.1566 7.04713 15.0186 7.3801 15.0186 7.72729C15.0186 8.07448 15.1566 8.40746 15.4021 8.65296C15.6476 8.89846 15.9805 9.03638 16.3277 9.03638C16.6749 9.03638 17.0079 8.89846 17.2534 8.65296C17.4989 8.40746 17.6368 8.07448 17.6368 7.72729C17.6368 7.3801 17.4989 7.04713 17.2534 6.80162C17.0079 6.55612 16.6749 6.4182 16.3277 6.4182ZM7.81864 10.8161L13.8326 16.8909H3.23683V15.3979L7.81864 10.8161ZM15.0186 12.1252L18.9459 16.0525V16.8909H15.6935L12.9732 14.1497L15.0186 12.1252Z"
            fill="#E2E2E2"
          />
        </svg>
      </Avatar>
    </Grid>
  )
}
